export default __webpack_public_path__ + "static/media/Member-login-Registration.14474344.png";